import * as z from "zod";

export const deleteReplenishmentRequestViewFolder = {
  name: "deleteReplenishmentRequestViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
